import React from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';

import actions from '@/actions';
import Select from '@/components/ui/kit/Select';
import { NotifierService as notifier } from '@/libs/Notifier';

// prettier-ignore
const COMMAND_OPTIONS = [
  { value: 'autotuneEnable',   label: 'Autotune Enable',   firmwares: ['ardupilot'] },
  { value: 'setRoiNone',       label: 'Cancel ROI' },
  { value: 'changeAltitude',   label: 'Change Altitude',   firmwares: ['ardupilot'] },
  { value: 'changeSpeed',      label: 'Change Speed' },
  { value: 'cycleRelay',       label: 'Cycle Relay',       firmwares: ['ardupilot'] },
  { value: 'cycleServo',       label: 'Cycle Servo',       firmwares: ['ardupilot'] },
  { value: 'delayUntil',       label: 'Delay Until' },
  { value: 'gripper',          label: 'Gripper',           firmwares: ['ardupilot'] },
  { value: 'guidedEnable',     label: 'Guided Enable',     firmwares: ['ardupilot'] },
  { value: 'guidedLimits',     label: 'Guided Limits',     firmwares: ['ardupilot'] },
  { value: 'jumpToItem',       label: 'Jump To Item' },
  { value: 'returnToLaunch',   label: 'Return To Launch' },
  { value: 'setRelay',         label: 'Set Relay',         firmwares: ['ardupilot'] },
  { value: 'setServo',         label: 'Set Servo' },
  { value: 'triggerParachute', label: 'Trigger Parachute', firmwares: ['ardupilot'] },
  { value: 'vtolTransition',   label: 'VTOL Transition',   firmwares: ['ardupilot'], frames: ['vtol'] },
  { value: 'waitForDistance',  label: 'Wait For Distance', firmwares: ['ardupilot'] },
  { value: 'waitForYaw',       label: 'Wait For Yaw',      firmwares: ['ardupilot'] },
];

// 옵션 가시성 판단
const isOptionVisible = (option, specs) => {
  if (option.firmwares && !option.firmwares.includes(specs.firmware)) {
    return false;
  }
  if (option.frames && !option.frames.includes(specs.frame)) {
    return false;
  }
  return true;
};

const AddCommandSelect = () => {
  const store = useStore();
  const dispatch = useDispatch();
  const moveFromIndex = useSelector((state) => state.editor.moveFromIndex);
  const commands = useSelector((state) => state.mission.json.commands);
  const specs = useSelector((state) => state.mission.json.specs);

  const addCommand = (e) => {
    if (store.getState().map3d.isShow) {
      notifier.error('Commands cannot be added in 3D map.');
      return;
    }

    if (commands.length === 0) {
      notifier.error('Please add a takeoff point first.');
      return;
    }

    switch (e.target.value) {
      case 'autotuneEnable':
        dispatch(actions.mission.mavlink.appendAutotuneEnable());
        break;

      case 'changeAltitude':
        {
          const { altitude } = store.getState().editor.config;
          dispatch(actions.mission.mavlink.appendChangeAltitude(altitude));
        }
        break;

      case 'changeSpeed':
        {
          const { speed } = store.getState().editor.config;
          dispatch(actions.mission.mavlink.appendChangeSpeed(speed));
        }
        break;

      case 'cycleRelay':
        dispatch(actions.mission.mavlink.appendCycleRelay());
        break;

      case 'cycleServo':
        dispatch(actions.mission.mavlink.appendCycleServo());
        break;

      case 'delayUntil':
        dispatch(actions.mission.mavlink.appendDelayUntil());
        break;

      case 'gripper':
        dispatch(actions.mission.mavlink.appendGripper());
        break;

      case 'guidedEnable':
        dispatch(actions.mission.mavlink.appendGuidedEnable());
        break;

      case 'guidedLimits':
        dispatch(actions.mission.mavlink.appendGuidedLimits());
        break;

      case 'jumpToItem':
        dispatch(actions.mission.mavlink.appendJumpToItem());
        break;

      case 'returnToLaunch':
        dispatch(actions.mission.appendReturnToLaunch());
        break;

      case 'setRelay':
        dispatch(actions.mission.mavlink.appendSetRelay());
        break;

      case 'setRoiNone':
        dispatch(actions.mission.mavlink.appendSetRoiNone());
        break;

      case 'setServo':
        dispatch(actions.mission.mavlink.appendSetServo());
        break;

      case 'triggerParachute':
        dispatch(actions.mission.mavlink.appendTriggerParachute());
        break;

      case 'vtolTransition':
        dispatch(actions.mission.mavlink.appendVtolTransition());
        break;

      case 'waitForDistance':
        dispatch(actions.mission.mavlink.appendWaitForDistance());
        break;

      case 'waitForYaw':
        dispatch(actions.mission.mavlink.appendWaitForYaw());
        break;

      default:
        break;
    }
  };

  const visibleOptions = COMMAND_OPTIONS.filter((option) => isOptionVisible(option, specs));

  return (
    <Select onChange={addCommand} disabled={moveFromIndex !== null} align="right">
      {visibleOptions.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </Select>
  );
};

export default AddCommandSelect;
